import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=355288f1"
import script from "./ProductOffers.vue?vue&type=script&lang=js"
export * from "./ProductOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports